var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGplayRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47235e-06 14.9067V1.09333C3.47235e-06 0.613333 0.271326 0.195556 0.665169 0L8.437 8L0.665169 16C0.464946 15.8989 0.296494 15.7429 0.178955 15.5497C0.061416 15.3565 -0.000534358 15.1338 3.47235e-06 14.9067ZM10.8963 10.5333L2.40682 15.5822L9.10217 8.68445L10.8963 10.5333ZM13.5394 7.03111C13.6823 7.1462 13.7978 7.29244 13.8776 7.45901C13.9573 7.62558 13.9991 7.80822 14 7.99342C14.0008 8.17862 13.9607 8.36164 13.8825 8.52895C13.8043 8.69626 13.69 8.84358 13.5482 8.96L11.7453 10.0356L9.77609 8L11.7453 5.96444L13.5394 7.03111ZM2.40682 0.417779L10.8963 5.46667L9.10217 7.30667L2.40682 0.417779Z",
    fill: "#FF1C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGplayRed);
export default __webpack_public_path__ + "static/media/ic_gplay_red.fe6a0077cb08f2d81e6ef1d6cc697296.svg";
export { ForwardRef as ReactComponent };